<div style="padding: 20px 22px; max-height: 90vh; display: flex; flex-direction: column;">

  <!-- Header -->
  <div style="display: flex; align-items: center; gap: 10px; border-bottom: 1px solid #e5e7eb; padding-bottom: 14px; margin-bottom: 14px;">
    <mat-icon style="color: #1C593D;">fact_check</mat-icon>
    <div style="flex: 1;">
      <h2 style="font-size: 1.05rem; font-weight: 800; color: #1e5a3f; margin: 0;">
        Completá los datos del beneficiario
      </h2>
      <p style="font-size: 0.76rem; color: #6b7280; margin: 2px 0 0;">
        {{ data.varianteLabel || data.variante }} · faltan algunos datos para enviar
      </p>
    </div>
    <button type="button" (click)="cancel()" [disabled]="saving"
      style="background: transparent; border: none; cursor: pointer; color: #6b7280; padding: 4px;">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Campos faltantes -->
  <div style="flex: 1; overflow-y: auto; padding-right: 4px;">
    <div *ngFor="let field of fields" style="margin-bottom: 14px;" [id]="'cmp-field-' + field.key">
      <label style="display: block; font-size: 0.82rem; color: #374151; font-weight: 600; margin-bottom: 6px;">
        {{ field.name }}
        <span *ngIf="field.min && field.type === 'text'" style="color: #9ca3af; font-weight: 500;">
          ({{ field.min }}{{ field.max ? '–' + field.max : '' }} caracteres)
        </span>
      </label>

      <input *ngIf="field.type === 'text'" type="text"
        [(ngModel)]="values[field.key]"
        (input)="onInput(field, $event)" (blur)="onBlur(field)"
        [maxlength]="field.max || null"
        style="width: 100%; padding: 10px 12px; border: 2px solid #e5e7eb; border-radius: 10px; font-size: 0.9rem; outline: none; box-sizing: border-box; text-transform: uppercase;"
        [style.border-color]="errors[field.key] ? '#fecaca' : '#e5e7eb'" />

      <input *ngIf="field.type === 'email'" type="email"
        [(ngModel)]="values[field.key]"
        (input)="onInput(field, $event)" (blur)="onBlur(field)"
        style="width: 100%; padding: 10px 12px; border: 2px solid #e5e7eb; border-radius: 10px; font-size: 0.9rem; outline: none; box-sizing: border-box;"
        [style.border-color]="errors[field.key] ? '#fecaca' : '#e5e7eb'" />

      <select *ngIf="field.type === 'select'"
        [(ngModel)]="values[field.key]" (change)="onBlur(field)" (blur)="onBlur(field)"
        style="width: 100%; padding: 10px 12px; border: 2px solid #e5e7eb; border-radius: 10px; font-size: 0.9rem; outline: none; box-sizing: border-box; background: white;"
        [style.border-color]="errors[field.key] ? '#fecaca' : '#e5e7eb'">
        <option value="">— Seleccionar —</option>
        <option *ngFor="let opt of field.options || []" [value]="opt.value">{{ opt.label }}</option>
      </select>

      <input *ngIf="field.type !== 'text' && field.type !== 'email' && field.type !== 'select'"
        type="text" [(ngModel)]="values[field.key]"
        (input)="onInput(field, $event)" (blur)="onBlur(field)"
        style="width: 100%; padding: 10px 12px; border: 2px solid #e5e7eb; border-radius: 10px; font-size: 0.9rem; outline: none; box-sizing: border-box; text-transform: uppercase;" />

      <div *ngIf="!errors[field.key] && hintForField(field)"
        style="margin-top: 4px; font-size: 0.7rem; color: #9ca3af;">
        {{ hintForField(field) }}
      </div>
      <div *ngIf="errors[field.key]"
        style="margin-top: 4px; font-size: 0.72rem; color: #b91c1c; font-weight: 600;">
        <mat-icon style="font-size: 12px; width: 12px; height: 12px; vertical-align: middle;">error_outline</mat-icon>
        {{ errors[field.key] }}
      </div>
    </div>
  </div>

  <!-- Error server -->
  <div *ngIf="serverError"
    style="margin: 6px 0 0; padding: 10px 12px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; font-size: 0.78rem; color: #b91c1c;">
    {{ serverError }}
  </div>

  <!-- Acciones -->
  <div style="display: flex; gap: 10px; justify-content: flex-end; border-top: 1px solid #e5e7eb; padding-top: 14px; margin-top: 14px;">
    <button type="button" (click)="cancel()" [disabled]="saving"
      style="padding: 9px 18px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer;">
      Cancelar
    </button>
    <button type="button" (click)="save()" [disabled]="saving"
      style="padding: 9px 22px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer;"
      [style.opacity]="saving ? 0.6 : 1">
      {{ saving ? 'Guardando…' : 'Guardar y continuar' }}
    </button>
  </div>
</div>
